import { useNavigate, NavigateOptions } from "react-router-dom";

export function useAppNavigate() {
    const navigate = useNavigate();

    return (to: string, options?: NavigateOptions) => {
        return navigate(to, { replace: true, ...options });
    };
}
